import { render, staticRenderFns } from "./PianoControllo.vue?vue&type=template&id=06a29a60&"
import script from "./PianoControllo.vue?vue&type=script&lang=js&"
export * from "./PianoControllo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports